import React from 'react';
import LottieLoading from '../common/LottieLoading';

const CourseLoadingAnimation: React.FC = () => {
    return (
        <LottieLoading
            message="Chargement du contenu..."
            fullScreen={true}
            animationType="learner"
        />
    );
};

export default CourseLoadingAnimation;
